export enum ExportTimesheetTypes {
  AdpApmt = 1,
  AdpAps,
  MaritechCsc,
  MaritechRoro,
  Paycom,
  PaycomRoro,
  RedHook,
  Wgma,
  AdpSsa,
  AdpSsaMorehead,
  AdpSfct,
  Proliant
}
